<template>
  <div class="Chapter" :style="{ width: width + 'px' }">
    <canvas ref="canvas" />
    <video v-if="$root.isModeVideo" ref="video" playsinline muted :src="chapter.videoURL" seeking="true" />
    <template v-if="loadedAndMounted">
      <Biorythme ref="timeline" v-if="ready" />
      <Comp ref="chapter" v-if="chapter.key == 'introduction' || !$root.isModeVideo" :is="chapterComp[chapter.key]" />
      <CTANext ref="cta" :tl="tl" />
    </template>
    <ChapterIntro ref="chapter_intro" :chapter="chapter" />
    <ChapterOutro ref="chapter_outro" :chapter="chapter" />
    <transition name="Chapter__loader">
      <div class="Chapter__loader" v-if="!loadedAndMounted">
				<div class="Chapter__loader-spin"/>
        <div class="Chapter__loader-text" v-html="trans('loader')"/>
			</div>
    </transition>
    <Debugger ref="debugger"/>
  </div>
</template>

<script>
import { Application, Loader } from 'pixi.js'
import Biorythme from '@/components/biorythme/Biorythme'
import CTANext from '@/components/cta-next/CTANext'
import Introduction from '@/components/chapters/introduction/Introduction'
import ConfederationHall from '@/components/chapters/confederation-hall/ConfederationHall'
import HouseOfCommons from '@/components/chapters/house-of-commons/HouseOfCommons'
import LibraryOfParliament from '@/components/chapters/library-of-parliament/LibraryOfParliament'
import PeaceTower from '@/components/chapters/peace-tower/PeaceTower'
import Senate from '@/components/chapters/senate/Senate'
import ChapterIntro from '@/components/chapter/ChapterIntro'
import ChapterOutro from '@/components/chapter/ChapterOutro'
import Debugger from '@/components/debugger/Debugger'

export default {
  name: 'Chapter',
  components: { Biorythme, CTANext, Introduction, ConfederationHall, HouseOfCommons, LibraryOfParliament, PeaceTower, Senate, ChapterIntro, ChapterOutro, Debugger },
  watch: {
    '$root.width': 'resize',
    '$root.height': 'resize',
    '$route': 'setReverseUrl',
  },
  beforeDestroy() {
    if(this.chapter.$pixi)
      this.chapter.$pixi.destroy()
    this.chapter.$tl.kill()
    this.setReverseUrl = null
    this.createTl = null
    this.load = null
    this.resize = null

    document.removeEventListener('visibilitychange', this.checkVisibility)
    window.removeEventListener('focus', this.focus)
    window.removeEventListener('blur', this.blur)

  },
  computed: {
    loadedAndMounted() {
      if(this.chapter.key == 'introduction') return true
      return !this.isLoading && this.mounted
    }
  },
  data: () => ({
    width: 1,
    canvas_width: 768,
    canvas_height: 1080,
    isIPhone: false,
    tl: {
      status: null,
      time: null,
      rythme: { name: null, type: null }
    },
    isLoading: true,
    mounted: false,
    chapter: null,
    chapterComp: {
      introduction: 'Introduction',
      confederation_hall: 'ConfederationHall',
      house_of_commons: 'HouseOfCommons',
      library_of_parliament: 'LibraryOfParliament',
      senate: 'Senate',
      peace_tower: 'PeaceTower'
    },
    ready: false
  }),

  translations: {
    fr: {
      loader: "Merci de patienter, le téléchargement de l’expérience peut prendre un moment.",

    },
    en: {
      loader: "Thank you for waiting. Loading the experience can take a moment.",
    }
  },


  created: async function() {

    // this.isIPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream
    // if(this.isIPhone) {
    //   if(this.$route.query.forceReload === undefined) {
    //     const reload = this.$router.resolve({ query: { forceReload: true} })
    //     window.location.href = reload.href

    //     // window.alert('.')
    //     // window.open(reload.href)
    //     // window.close()

    //   } else {
    //     this.$router.push({ query: { forceReload: undefined } })
    //   }
    // }

    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
    this.setReverseUrl()
    this.createTl()

    if(!this.chapter.$loader && !this.$root.isModeVideo)
      await this.load()

    this.isLoading = false
  },
  mounted: async function() {

    document.addEventListener('visibilitychange', this.checkVisibility)
    window.addEventListener('focus', this.focus)
    window.addEventListener('blur', this.blur)

    this.$refs.debugger.useDebugger('debugger') 

    if(!this.$root.isModeVideo) {
      this.chapter.$pixi = new Application({
        view: this.$refs.canvas,
        height: this.canvas_height,
        width: this.canvas_width,
        backgroundColor: 0xdcd5c4
      })
    }

    this.resize()

    if(this.$root.isModeVideo) {
      this.chapter.$video = this.$refs.video
      if(this.chapter.key != 'introduction') {
        await this.checkVideo()
        console.log('await completed!');
      }
    }

    TweenLite.delayedCall(1, () => this.ready = true)
    TweenLite.delayedCall(2, () => this.mounted = true)

    // await this.checkVideo()
    // this.isLoading = false
  },
  methods: {

    focus() { 
      this.$refs.debugger.useDebugger('focus') 
      // if(this.ready)
      //   this.$refs.timeline.focus()
    },
    blur() {
      this.$refs.debugger.useDebugger('blur') 
      if(this.ready)
        this.$refs.timeline.blur()
    },
    checkVisibility() {
      this.$refs.debugger.useDebugger('checkvisibility')  
      if(this.ready)
        this.$refs.timeline.checkVisibility()
    },

    checkVideo() {
      return new Promise(res => {
        this.$refs.video.addEventListener('canplaythrough',() => {
          console.log('canplaythrough');
          res()
        })
        this.$refs.video.load()
        console.log('load');

      })
    },
    setReverseUrl() {
      this.$root.commonsTranslations = {
        en: { Route: { params: { chapter: this.chapter.en.slug }} },
        fr: { Route: { params: { chapter: this.chapter.fr.slug }} }
      }
    },
    createTl() {
      this.chapter.$tl = new TimelineMax({
        id: 'Master',
        paused: true,
        onUpdate: () => {
          this.tl.status = this.chapter.$tl.paused() ? 'pause' : 'play'
          this.tl.time = this.chapter.$tl.time()
        }
      })
    },
    load() {
      return new Promise(res => {
        this.chapter.$loader = new Loader()
        _.each(this.chapter.library, asset =>{
          if(this.isException(asset.title) == false
          && this.isMP4(asset.url) == false) {
            this.chapter.$loader.add(asset.title, asset.url)
          }
        })
        this.chapter.$loader.load()
        this.chapter.$loader.onComplete.add(res)
      })
    },
    resize() {
      this.width = this.$el.offsetHeight * (3/4)
      TweenLite.set(this.$refs.canvas, { scale: this.width / this.canvas_width  })
      // const scale = (this.$el.offsetHeight / this.$el.offsetWidth > this.canvas_height / this.canvas_width )
      // ? this.width / this.canvas_width
      // : this.canvas_width / this.width
    },

    isMP4(str) {
      if(str.indexOf('mp4') != -1 && this.$root.isModeVideo == false
      || str.indexOf('mp3') != -1 && this.$root.isModeVideo == false) {
        console.log(str);
        return true
      }
      else
        return false
    },

    isException(str) {

      if(this.$root.above('tablet') && /iPad|iPhone|iPod/.test(navigator.platform) == false)
        return false

      const exceptions = [
        'swipe_half',
        'bkg_half',
        'blur_half',
        'blur_reverse_half',
        'large_half',
        'swipe1_half',
        'b2',
        'b3',
        'b4',
        'b11',
        'b12',
        'b13',
        'b14',
        'b31',
        'b41',
        'bancs_s9',
        'medium_8',
        'medium_17',
        'plafond_hd',
        'wave',
        'masque',
        'grad1',
        'gradient2',
        'bg_s16',
        'bg2_s16',
        'gradient_bkg_image',
        'gradient_bkg2',
        'grad2',
        'grad3',
        'grad4',
      ]

      let b = false
     _.each(exceptions, (except)=>{
        if(str == except)
          b = true
      })
      return b
    },

  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Chapter
  position absolute
  transition opacity 1s
  height 100%
  overflow hidden
  +portrait()
    width 100% !important

  &-enter
  &-leave-active
    opacity 0

  &__loader
    position absolute
    top 0
    left 0
    bottom 60px
    right 0
    &-enter
    &-leave-active
      opacity 0
    &-spin
      position absolute
      left 50%
      margin -15px 0 0 -15px
      border 2px solid rgba(white, .5)
      border-top 2px solid rgba(black, 0)
      border-radius 50%
      width 30px
      height 30px
      animation Loader__spin 2s linear infinite
      bottom 50px
      @keyframes Loader__spin {
        from { transform: rotate(0deg) }
        to { transform: rotate(360deg) }
      }

    &-text
      text-align center
      position absolute
      bottom -30px
      padding 0 32px
      left 50%
      transform translateX(-50%)
      min-width 256px

  &__next
    position absolute
    bottom 0
    background green
    padding 10px 20px
    left 50%
    transform translateX(-50%)
    cursor pointer

  video
    position absolute
    left 0%
    top 0%
    width 100%
    height 100%
    object-fit cover
    pointer-events none

  canvas
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)

</style>
